export function DashboardSkeleton() {
	return (
		<div className="animate-pulse space-y-4" aria-busy="true" aria-label="Carregando painel">
			<div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
				{[0, 1, 2, 3].map(i => (
					<div key={i} className="h-32 rounded-2xl bg-raro-gray-200" />
				))}
			</div>
			<div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
				<div className="h-80 rounded-2xl bg-raro-gray-200 lg:col-span-2" />
				<div className="h-80 rounded-2xl bg-raro-gray-200" />
				<div className="h-80 rounded-2xl bg-raro-gray-200 lg:col-span-2" />
				<div className="h-80 rounded-2xl bg-raro-gray-200" />
			</div>
		</div>
	);
}
